(self["webpackChunk"] = self["webpackChunk"] || []).push([[421,662,169,393],{

/***/ 7608:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(56187);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(38690);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(89228);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.to-primitive.js
var es_symbol_to_primitive = __webpack_require__(26031);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(84159);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91270);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(13227);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(88646);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.date.to-primitive.js
var es_date_to_primitive = __webpack_require__(95822);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(48949);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(11908);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(39574);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.set-prototype-of.js
var es_object_set_prototype_of = __webpack_require__(43908);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(81414);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(37666);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__(36763);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(59139);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(54134);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(14011);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.weak-map.js
var es_weak_map = __webpack_require__(84750);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.weak-set.js
var es_weak_set = __webpack_require__(77991);
// EXTERNAL MODULE: ../node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(11431);
// EXTERNAL MODULE: ./utils/lodash.js
var lodash = __webpack_require__(31955);
// EXTERNAL MODULE: ./api/ab-test.js
var ab_test = __webpack_require__(84061);
// EXTERNAL MODULE: ./snippets/_/utils/base-custom-elements.js
var base_custom_elements = __webpack_require__(18335);
// EXTERNAL MODULE: ./snippets/original-main-product/quick-add-to-cart/index.js + 1 modules
var quick_add_to_cart = __webpack_require__(98120);
// EXTERNAL MODULE: ./utils/event-handler.js
var event_handler = __webpack_require__(25675);
// EXTERNAL MODULE: ./utils/rIC.js
var rIC = __webpack_require__(24681);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(96626);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__(92815);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__(86651);
// EXTERNAL MODULE: ./utils/impression-tracking.js
var impression_tracking = __webpack_require__(85097);
// EXTERNAL MODULE: ./utils/number-precision.js
var number_precision = __webpack_require__(69784);
;// CONCATENATED MODULE: ./sections/video-merchant/src/event-tracking.js
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }


















var getVideoCreativeName = function getVideoCreativeName(videoElement) {
  var _videoElement$dataset, _videoElement$getAttr;
  if (!videoElement) return undefined;
  return videoElement.src || ((_videoElement$dataset = videoElement.dataset) === null || _videoElement$dataset === void 0 ? void 0 : _videoElement$dataset.src) || ((_videoElement$getAttr = videoElement.getAttribute) === null || _videoElement$getAttr === void 0 ? void 0 : _videoElement$getAttr.call(videoElement, 'data-src')) || undefined;
};
var getProductEcommerce = function getProductEcommerce(target) {
  var wrapperElement = target.closest('.video-merchant__item');
  if (!wrapperElement) {
    return;
  }
  return {
    item_list_id: wrapperElement.dataset.listId,
    item_list_name: wrapperElement.dataset.listName,
    item_category: target.dataset.productType,
    item_id: target.dataset.productId,
    item_name: target.dataset.productTitle,
    item_variant: target.dataset.variantSku,
    item_category5: target.dataset.variantSku,
    item_brand: target.dataset.variantTitle,
    item_category4: target.dataset.variantId,
    price: target.dataset.price,
    index: target.dataset.index,
    quantity: '1',
    currency: 'USD',
    flow_group: 'none'
  };
};
var handleVideoMerchantImpression = function handleVideoMerchantImpression() {
  // 曝光
  (0,impression_tracking/* default */.Z)('.video-merchant__item .video-merchant__item__info', function () {
    var targetList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var items = targetList.map(function (item) {
      return getProductEcommerce(item);
    });
    var price = items.reduce(function (r, item) {
      r = number_precision/* default */.Z.plus(r, item.price);
      return r;
    }, 0);
    var data = {
      event: 'eeEvent',
      event_type: 'view_item_list',
      ecommerce: {
        event_label: 'Video Merchant',
        currency: 'USD',
        value: price,
        product_id: '',
        items: items
      }
    };
    window.dataLayer.push({
      ecommerce: null
    }, data);
  }, false, true, 500);
  (0,impression_tracking/* default */.Z)('.video-merchant__item__video', function () {
    var targetList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var _iterator = _createForOfIteratorHelper(targetList),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _target$querySelector, _target$closest;
        var target = _step.value;
        var videoElement = target.querySelector('video');
        var creativeName = getVideoCreativeName(videoElement);
        var promotionName = (_target$querySelector = target.querySelector('video')) === null || _target$querySelector === void 0 || (_target$querySelector = _target$querySelector.dataset) === null || _target$querySelector === void 0 ? void 0 : _target$querySelector.posterAlt;
        var creativeSlot = (_target$closest = target.closest('video-merchant')) === null || _target$closest === void 0 || (_target$closest = _target$closest.querySelector('.video-merchant__title')) === null || _target$closest === void 0 || (_target$closest = _target$closest.textContent) === null || _target$closest === void 0 ? void 0 : _target$closest.trim();
        var item = {
          creative_name: creativeName || 'none',
          promotion_name: promotionName || 'none',
          creative_slot: creativeSlot || 'none'
        };
        var data = {
          event: 'eeEvent',
          event_type: 'view_video',
          ecommerce: {
            items: [item]
          }
        };
        window.dataLayer.push({
          ecommerce: null
        }, data);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }, false, true, 500);
};
var filledPoint = function filledPoint() {
  // 点击播放视频埋点
  (0,event_handler.on)('click', '.video-merchant__item__video video, .video-merchant__item__video .video-merchant__item__video__icon', function (event) {
    var target = event.target.closest('.video-merchant__item__video');
    if (!target) return;
    if (target.classList.contains('video-merchant__item__video--play')) {
      var _target$querySelector2, _target$closest2;
      var videoElement = target.querySelector('video');
      var creativeName = getVideoCreativeName(videoElement);
      var promotionName = (_target$querySelector2 = target.querySelector('video')) === null || _target$querySelector2 === void 0 || (_target$querySelector2 = _target$querySelector2.dataset) === null || _target$querySelector2 === void 0 ? void 0 : _target$querySelector2.posterAlt;
      var creativeSlot = (_target$closest2 = target.closest('video-merchant')) === null || _target$closest2 === void 0 || (_target$closest2 = _target$closest2.querySelector('.video-merchant__title')) === null || _target$closest2 === void 0 || (_target$closest2 = _target$closest2.textContent) === null || _target$closest2 === void 0 ? void 0 : _target$closest2.trim();
      var data = {
        event: 'eeEvent',
        event_type: 'click_video',
        ecommerce: {
          items: [{
            creative_name: creativeName || 'none',
            promotion_name: promotionName || 'none',
            creative_slot: creativeSlot || 'none'
          }]
        }
      };
      window.dataLayer.push({
        ecommerce: null
      }, data);
    }
  });
  // 点击展开收起埋点
  (0,event_handler.on)('click', '.video-merchant__handler__icon--more', function (event) {
    event.stopPropagation();
    setTimeout(function () {
      var target = event.target.closest('.video-merchant__item.product-block');
      if (!target) return;
      var drawer = target.querySelector('.video-merchant__item__drawer');
      var data = {
        event: 'uaEvent',
        event_type: 'video_shopping',
        event_label: drawer.classList.contains('video-merchant__item__drawer--active') ? 'expand' : 'collapse'
      };
      window.dataLayer.push({
        ecommerce: null
      }, data);
    }, 500);
  });

  // 点击进商详
  (0,event_handler.on)('click', '.video-merchant__product-title', function (event) {
    var currentTarget = event.currentTarget;
    var productElement = currentTarget.closest('.video-merchant__item__info');
    if (!productElement) {
      return;
    }
    var product = getProductEcommerce(productElement);
    var data = {
      event: 'eeEvent',
      event_type: 'select_item',
      ecommerce: {
        value: productElement.dataset.price,
        currency: 'USD',
        event_label: 'Product Detail',
        product_id: product.item_id,
        items: [product]
      }
    };
    window.dataLayer.push({
      ecommerce: null
    }, data);
  });
};
;// CONCATENATED MODULE: ./sections/video-merchant/src/custom-elements.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || custom_elements_unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || custom_elements_unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return custom_elements_arrayLikeToArray(r); }
function custom_elements_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = custom_elements_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function custom_elements_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return custom_elements_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? custom_elements_arrayLikeToArray(r, a) : void 0; } }
function custom_elements_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }






















function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }








/**
 * 常量定义
 */
var DEBOUNCE_DELAY_MS = 33; // IntersectionObserver 回调防抖延迟（约 2 帧）
var _videoElements = /*#__PURE__*/new WeakMap();
var _intersectionObserver = /*#__PURE__*/new WeakMap();
var _posterObserver = /*#__PURE__*/new WeakMap();
var _VideoMerchant_brand = /*#__PURE__*/new WeakSet();
var _handleTogglePlay = /*#__PURE__*/new WeakMap();
var VideoMerchant = /*#__PURE__*/function (_BaseCustomElements) {
  function VideoMerchant() {
    var _this;
    _classCallCheck(this, VideoMerchant);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, VideoMerchant, [].concat(args));
    _classPrivateMethodInitSpec(_this, _VideoMerchant_brand);
    _classPrivateFieldInitSpec(_this, _videoElements, void 0);
    _classPrivateFieldInitSpec(_this, _intersectionObserver, void 0);
    _classPrivateFieldInitSpec(_this, _posterObserver, void 0);
    _classPrivateFieldInitSpec(_this, _handleTogglePlay, function (video) {
      // 懒加载：首次播放时加载视频源
      _assertClassBrand(_VideoMerchant_brand, _this, _loadVideoSource).call(_this, video);
      if (video.paused) {
        video.play().catch(function (error) {
          console.log('播放失败:', error);
        });
        var _iterator = custom_elements_createForOfIteratorHelper(_classPrivateFieldGet(_videoElements, _this)),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var element = _step.value;
            if (video !== element) {
              element.pause();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        video.pause();
      }
      var _iterator2 = custom_elements_createForOfIteratorHelper(_classPrivateFieldGet(_videoElements, _this)),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _element = _step2.value;
          var wrapperElement = _element.closest('.video-merchant__item__video');
          if (_element.paused) {
            wrapperElement.classList.remove('video-merchant__item__video--play');
          } else {
            wrapperElement.classList.add('video-merchant__item__video--play');
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    });
    return _this;
  }
  _inherits(VideoMerchant, _BaseCustomElements);
  return _createClass(VideoMerchant, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _assertClassBrand(_VideoMerchant_brand, this, _setup).call(this);
      _assertClassBrand(_VideoMerchant_brand, this, _bindEvents).call(this);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _classPrivateFieldGet2, _classPrivateFieldGet3, _classPrivateFieldGet4, _classPrivateFieldGet5;
      (0,event_handler/* offByContainer */.g4)(this);
      (_classPrivateFieldGet2 = _classPrivateFieldGet(_intersectionObserver, this)) === null || _classPrivateFieldGet2 === void 0 || (_classPrivateFieldGet3 = _classPrivateFieldGet2.disconnect) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.call(_classPrivateFieldGet2);
      (_classPrivateFieldGet4 = _classPrivateFieldGet(_posterObserver, this)) === null || _classPrivateFieldGet4 === void 0 || (_classPrivateFieldGet5 = _classPrivateFieldGet4.disconnect) === null || _classPrivateFieldGet5 === void 0 || _classPrivateFieldGet5.call(_classPrivateFieldGet4);
    }
  }]);
}(base_custom_elements/* default */.Z);
function _setup() {
  var _this2 = this;
  _classPrivateFieldSet(_videoElements, this, _toConsumableArray(this.querySelectorAll('video')));

  // 检测用户是否偏好减少动画
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  this.setState(function (draft) {
    // 如果用户偏好减少动画，强制禁用自动播放
    draft.autoPlay = _this2.getAttribute('auto-play') === 'true' && !prefersReducedMotion;
  });
  _assertClassBrand(_VideoMerchant_brand, this, _handleAutoPlayFirstVideoObserver).call(this);
  _assertClassBrand(_VideoMerchant_brand, this, _lazyPoster).call(this);
  _assertClassBrand(_VideoMerchant_brand, this, _activateVideoMerchant).call(this);
}
/**
 * 激活 VideoMerchant 并触发曝光追踪
 * @description 统一处理 VideoMerchant 激活逻辑，避免重复调用
 */
function _activateVideoMerchant() {
  this.dataset.spin = 'false';
  handleVideoMerchantImpression();
}
/**
 * 加载视频源
 * @param {HTMLVideoElement} video - 视频元素
 * @description 将 data-src 属性的值设置为 src，触发视频加载
 */
function _loadVideoSource(video) {
  if (video.src || !video.dataset.src) {
    return;
  }
  video.src = video.dataset.src;
  delete video.dataset.src;
}
function _handleAutoPlayFirstVideoObserver() {
  var _this3 = this;
  var _classPrivateFieldGet6 = _classPrivateFieldGet(_videoElements, this),
    _classPrivateFieldGet7 = _slicedToArray(_classPrivateFieldGet6, 1),
    video = _classPrivateFieldGet7[0];
  var autoPlay = this.state.autoPlay;
  if (!video || !autoPlay) {
    return;
  }
  _classPrivateFieldSet(_intersectionObserver, this, new IntersectionObserver((0,lodash/* debounce */.Ds)(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(entries) {
      var _iterator3, _step3, entry, target, isIntersecting, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _iterator3 = custom_elements_createForOfIteratorHelper(entries);
            _context.p = 1;
            _iterator3.s();
          case 2:
            if ((_step3 = _iterator3.n()).done) {
              _context.n = 5;
              break;
            }
            entry = _step3.value;
            target = entry.target, isIntersecting = entry.isIntersecting;
            if (isIntersecting) {
              _context.n = 3;
              break;
            }
            return _context.a(3, 4);
          case 3:
            _classPrivateFieldGet(_intersectionObserver, _this3).unobserve(target);
            _classPrivateFieldGet(_handleTogglePlay, _this3).call(_this3, video);
          case 4:
            _context.n = 2;
            break;
          case 5:
            _context.n = 7;
            break;
          case 6:
            _context.p = 6;
            _t = _context.v;
            _iterator3.e(_t);
          case 7:
            _context.p = 7;
            _iterator3.f();
            return _context.f(7);
          case 8:
            return _context.a(2);
        }
      }, _callee, null, [[1, 6, 7, 8]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), DEBOUNCE_DELAY_MS), {
    rootMargin: '0px 0px 0px 0px',
    threshold: 0
  }));
  _classPrivateFieldGet(_intersectionObserver, this).observe(video);
}
function _lazyPoster() {
  var _this4 = this;
  var videos = this.querySelectorAll('video[data-poster]');
  _classPrivateFieldSet(_posterObserver, this, new IntersectionObserver(function (entries) {
    var _iterator4 = custom_elements_createForOfIteratorHelper(entries),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var entry = _step4.value;
        if (entry.isIntersecting) {
          var video = entry.target;
          if (!video.poster) {
            video.poster = video.dataset.poster;
            delete video.dataset.poster;
          }
          _classPrivateFieldGet(_posterObserver, _this4).unobserve(video);
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }, {
    rootMargin: '200px 0px 200px 0px',
    threshold: 0.01
  }));
  var _iterator5 = custom_elements_createForOfIteratorHelper(videos),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var video = _step5.value;
      _classPrivateFieldGet(_posterObserver, this).observe(video);
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
}
function _bindEvents() {
  var _this5 = this;
  (0,event_handler.on)('click', '.video-merchant__handler__icon--more', function (event) {
    var itemElement = event.currentTarget.closest('.video-merchant__item');
    var drawerElement = itemElement.querySelector('.video-merchant__item__drawer');
    var videoElement = itemElement.querySelector('video');
    var isInsideDrawer = event.currentTarget.closest('.video-merchant__item__drawer');
    if (!drawerElement) {
      return;
    }
    if (!videoElement.paused) {
      _classPrivateFieldGet(_handleTogglePlay, _this5).call(_this5, videoElement);
    }
    if (isInsideDrawer) {
      drawerElement.classList.remove('video-merchant__item__drawer--active');
    } else {
      drawerElement.classList.add('video-merchant__item__drawer--visible');
      (0,rIC/* rIC */.$)(function () {
        drawerElement.classList.add('video-merchant__item__drawer--active');
      });
    }
  }, {}, this);
  (0,event_handler.on)('click', '.video-merchant__item__video video', function (event) {
    var currentTarget = event.currentTarget;
    _classPrivateFieldGet(_handleTogglePlay, _this5).call(_this5, currentTarget);
  }, {}, this);
  (0,event_handler.on)('click', '.video-merchant__item__video__icon', function (event) {
    var currentTarget = event.currentTarget;
    var video = currentTarget.closest('.video-merchant__item__video').querySelector('video');
    _classPrivateFieldGet(_handleTogglePlay, _this5).call(_this5, video);
  }, {}, this);
  (0,event_handler.on)('click', '.video-merchant__item__video__icon__volume', function (event) {
    var currentTarget = event.currentTarget;
    var videoElement = currentTarget.closest('.video-merchant__item__video').querySelector('video');
    var soundOn = currentTarget.classList.contains('video-merchant__item__video__icon__volume--play');
    if (soundOn) {
      currentTarget.classList.remove('video-merchant__item__video__icon__volume--play');
      videoElement.muted = true;
    } else {
      currentTarget.classList.add('video-merchant__item__video__icon__volume--play');
      videoElement.muted = false;
    }
  }, {}, this);
  (0,event_handler.on)('click', '.video-merchant__handler__icon--add', function (event) {
    var productUrl = event.currentTarget.dataset.href;
    (0,quick_add_to_cart/* quickAddToCart */.G)({
      productUrl: productUrl,
      event: event
    });
  }, {}, this);
}
/* harmony default export */ var custom_elements = (VideoMerchant);
;// CONCATENATED MODULE: ./sections/video-merchant/index.js


var init = function init() {
  if (customElements.get('video-merchant')) {
    return;
  }
  customElements.define('video-merchant', custom_elements);
  filledPoint();
};
init();

/***/ }),

/***/ 40429:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [398,80,555,736,114,836], function() { return __webpack_exec__(7608); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);